import { __awaiter, __generator } from "tslib";
import { addNcpcCode } from '@ekuaibao/lib/lib/addNcpcCode';
import { app, callback } from '../index.v0';
import { newHomeConfig } from '../newHomeConfig';
import { initDatafluxRum } from '../dataflux-rum';
import QYWeiXinSDK from '@ekuaibao/sdk-bridge/sdk/qyweixin-v2';
import registerAPI from '../registerAPI';
import { initializeTitle } from '../initializeTitle';
import initPlatformInfo from '../initPlatformInfo';
import registerHandler from '../registerHandler';
import { initRoute } from '../initRoute';
import { initColors } from '../initColors';
import setNetworkAdapter from '../setNetworkAdapter';
import initLogger from '../../logger/initLogger';
import { loginInit } from './sso-init';
import { designate, PLATFORM_KEYWORD } from './designate';
import('../../styles/invisible.less');
initLogger();
designate();
initDatafluxRum();
function startup() {
    app.use({
        id: "@" + PLATFORM_KEYWORD.toLowerCase(),
        onready: function () {
            addNcpcCode();
        }
    });
    callback();
}
export var bootstrap = function () { return __awaiter(void 0, void 0, void 0, function () {
    var opts, error_1, _a, options, signatureInfo;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4, loginInit()];
            case 1:
                opts = _b.sent();
                return [3, 3];
            case 2:
                error_1 = _b.sent();
                console.error('loginInit failed', error_1);
                throw error_1;
            case 3:
                initColors();
                app.container.set('IDeviceType', 'DESKTOP');
                app.container.set('ISMessageEntry', false);
                app.sdk = app.container.get(QYWeiXinSDK);
                registerHandler();
                _a = opts || {}, options = _a.options, signatureInfo = _a.signatureInfo;
                return [4, app.sdk.initialize({
                        wxCorpId: options.wecomCorpId,
                        agentId: options.agentId,
                        getJSConfig: function (url, type) {
                            try {
                                var fields = {
                                    config: 'configSignature',
                                    agentConfig: 'agentConfigSignature'
                                };
                                return {
                                    timestamp: signatureInfo.timeStamp,
                                    nonceStr: signatureInfo.nonceStr,
                                    signature: signatureInfo[fields[type]]
                                };
                            }
                            catch (e) {
                                console.error("get signature error", e);
                                return {};
                            }
                        }
                    })];
            case 4:
                _b.sent();
                initRoute();
                initPlatformInfo();
                return [4, newHomeConfig()];
            case 5:
                _b.sent();
                initializeTitle();
                registerAPI();
                setNetworkAdapter();
                return [4, startup()];
            case 6:
                _b.sent();
                setNetworkAdapter();
                return [2];
        }
    });
}); };
